import(/* webpackMode: "eager", webpackExports: ["OverviewView"] */ "/opt/render/project/src/apps/web/src/features/portfolio/views/overview-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioView"] */ "/opt/render/project/src/apps/web/src/features/portfolio/views/portfolio-view.tsx");
